/*! modernizr 3.0.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-touchevents-printshiv !*/
!(function (e, t, n) {
  function o(e, t) {
    return typeof e === t;
  }
  function r() {
    var e, t, n, r, a, i, s;
    for (var l in f) {
      if (((e = []), (t = f[l]), t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)))
        for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
      for (r = o(t.fn, "function") ? t.fn() : t.fn, a = 0; a < e.length; a++)
        (i = e[a]),
          (s = i.split(".")),
          1 === s.length ? (Modernizr[s[0]] = r) : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), (Modernizr[s[0]][s[1]] = r)),
          c.push((r ? "" : "no-") + s.join("-"));
    }
  }
  function a(e) {
    var t = d.className,
      n = Modernizr._config.classPrefix || "";
    if ((m && (t = t.baseVal), Modernizr._config.enableJSClass)) {
      var o = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(o, "$1" + n + "js$2");
    }
    Modernizr._config.enableClasses && ((t += " " + n + e.join(" " + n)), m ? (d.className.baseVal = t) : (d.className = t));
  }
  function i() {
    return "function" != typeof t.createElement ? t.createElement(arguments[0]) : m ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
  }
  function s() {
    var e = t.body;
    return e || ((e = i(m ? "svg" : "body")), (e.fake = !0)), e;
  }
  function l(e, n, o, r) {
    var a,
      l,
      c,
      f,
      u = "modernizr",
      m = i("div"),
      p = s();
    if (parseInt(o, 10)) for (; o--; ) (c = i("div")), (c.id = r ? r[o] : u + (o + 1)), m.appendChild(c);
    return (
      (a = i("style")),
      (a.type = "text/css"),
      (a.id = "s" + u),
      (p.fake ? p : m).appendChild(a),
      p.appendChild(m),
      a.styleSheet ? (a.styleSheet.cssText = e) : a.appendChild(t.createTextNode(e)),
      (m.id = u),
      p.fake && ((p.style.background = ""), (p.style.overflow = "hidden"), (f = d.style.overflow), (d.style.overflow = "hidden"), d.appendChild(p)),
      (l = n(m, e)),
      p.fake ? (p.parentNode.removeChild(p), (d.style.overflow = f), d.offsetHeight) : m.parentNode.removeChild(m),
      !!l
    );
  }
  var c = [],
    f = [],
    u = {
      _version: "3.0.0",
      _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
      _q: [],
      on: function (e, t) {
        var n = this;
        setTimeout(function () {
          t(n[e]);
        }, 0);
      },
      addTest: function (e, t, n) {
        f.push({ name: e, fn: t, options: n });
      },
      addAsyncTest: function (e) {
        f.push({ name: null, fn: e });
      },
    },
    Modernizr = function () {};
  (Modernizr.prototype = u), (Modernizr = new Modernizr());
  var d = t.documentElement,
    m = "svg" === d.nodeName.toLowerCase();
  m ||
    !(function (e, t) {
      function n(e, t) {
        var n = e.createElement("p"),
          o = e.getElementsByTagName("head")[0] || e.documentElement;
        return (n.innerHTML = "x<style>" + t + "</style>"), o.insertBefore(n.lastChild, o.firstChild);
      }
      function o() {
        var e = S.elements;
        return "string" == typeof e ? e.split(" ") : e;
      }
      function r(e, t) {
        var n = S.elements;
        "string" != typeof n && (n = n.join(" ")), "string" != typeof e && (e = e.join(" ")), (S.elements = n + " " + e), c(t);
      }
      function a(e) {
        var t = N[e[T]];
        return t || ((t = {}), C++, (e[T] = C), (N[C] = t)), t;
      }
      function i(e, n, o) {
        if ((n || (n = t), v)) return n.createElement(e);
        o || (o = a(n));
        var r;
        return (
          (r = o.cache[e] ? o.cache[e].cloneNode() : b.test(e) ? (o.cache[e] = o.createElem(e)).cloneNode() : o.createElem(e)), !r.canHaveChildren || E.test(e) || r.tagUrn ? r : o.frag.appendChild(r)
        );
      }
      function s(e, n) {
        if ((e || (e = t), v)) return e.createDocumentFragment();
        n = n || a(e);
        for (var r = n.frag.cloneNode(), i = 0, s = o(), l = s.length; l > i; i++) r.createElement(s[i]);
        return r;
      }
      function l(e, t) {
        t.cache || ((t.cache = {}), (t.createElem = e.createElement), (t.createFrag = e.createDocumentFragment), (t.frag = t.createFrag())),
          (e.createElement = function (n) {
            return S.shivMethods ? i(n, e, t) : t.createElem(n);
          }),
          (e.createDocumentFragment = Function(
            "h,f",
            "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" +
              o()
                .join()
                .replace(/[\w\-:]+/g, function (e) {
                  return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")';
                }) +
              ");return n}"
          )(S, t.frag));
      }
      function c(e) {
        e || (e = t);
        var o = a(e);
        return (
          !S.shivCSS ||
            h ||
            o.hasCSS ||
            (o.hasCSS = !!n(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),
          v || l(e, o),
          e
        );
      }
      function f(e) {
        for (var t, n = e.getElementsByTagName("*"), r = n.length, a = RegExp("^(?:" + o().join("|") + ")$", "i"), i = []; r--; ) (t = n[r]), a.test(t.nodeName) && i.push(t.applyElement(u(t)));
        return i;
      }
      function u(e) {
        for (var t, n = e.attributes, o = n.length, r = e.ownerDocument.createElement(x + ":" + e.nodeName); o--; ) (t = n[o]), t.specified && r.setAttribute(t.nodeName, t.nodeValue);
        return (r.style.cssText = e.style.cssText), r;
      }
      function d(e) {
        for (var t, n = e.split("{"), r = n.length, a = RegExp("(^|[\\s,>+~])(" + o().join("|") + ")(?=[[\\s,>+~#.:]|$)", "gi"), i = "$1" + x + "\\:$2"; r--; )
          (t = n[r] = n[r].split("}")), (t[t.length - 1] = t[t.length - 1].replace(a, i)), (n[r] = t.join("}"));
        return n.join("{");
      }
      function m(e) {
        for (var t = e.length; t--; ) e[t].removeNode();
      }
      function p(e) {
        function t() {
          clearTimeout(i._removeSheetTimer), o && o.removeNode(!0), (o = null);
        }
        var o,
          r,
          i = a(e),
          s = e.namespaces,
          l = e.parentWindow;
        return !_ || e.printShived
          ? e
          : ("undefined" == typeof s[x] && s.add(x),
            l.attachEvent("onbeforeprint", function () {
              t();
              for (var a, i, s, l = e.styleSheets, c = [], u = l.length, m = Array(u); u--; ) m[u] = l[u];
              for (; (s = m.pop()); )
                if (!s.disabled && w.test(s.media)) {
                  try {
                    (a = s.imports), (i = a.length);
                  } catch (p) {
                    i = 0;
                  }
                  for (u = 0; i > u; u++) m.push(a[u]);
                  try {
                    c.push(s.cssText);
                  } catch (p) {}
                }
              (c = d(c.reverse().join(""))), (r = f(e)), (o = n(e, c));
            }),
            l.attachEvent("onafterprint", function () {
              m(r), clearTimeout(i._removeSheetTimer), (i._removeSheetTimer = setTimeout(t, 500));
            }),
            (e.printShived = !0),
            e);
      }
      var h,
        v,
        g = "3.7.3",
        y = e.html5 || {},
        E = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
        b = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
        T = "_html5shiv",
        C = 0,
        N = {};
      !(function () {
        try {
          var e = t.createElement("a");
          (e.innerHTML = "<xyz></xyz>"),
            (h = "hidden" in e),
            (v =
              1 == e.childNodes.length ||
              (function () {
                t.createElement("a");
                var e = t.createDocumentFragment();
                return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement;
              })());
        } catch (n) {
          (h = !0), (v = !0);
        }
      })();
      var S = {
        elements:
          y.elements ||
          "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
        version: g,
        shivCSS: y.shivCSS !== !1,
        supportsUnknownElements: v,
        shivMethods: y.shivMethods !== !1,
        type: "default",
        shivDocument: c,
        createElement: i,
        createDocumentFragment: s,
        addElements: r,
      };
      (e.html5 = S), c(t);
      var w = /^$|\b(?:all|print)\b/,
        x = "html5shiv",
        _ =
          !v &&
          (function () {
            var n = t.documentElement;
            return !(
              "undefined" == typeof t.namespaces ||
              "undefined" == typeof t.parentWindow ||
              "undefined" == typeof n.applyElement ||
              "undefined" == typeof n.removeNode ||
              "undefined" == typeof e.attachEvent
            );
          })();
      (S.type += " print"), (S.shivPrint = p), p(t), "object" == typeof module && module.exports && (module.exports = S);
    })("undefined" != typeof e ? e : this, t);
  var p = u._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : [];
  u._prefixes = p;
  var h = (u.testStyles = l);
  Modernizr.addTest("touchevents", function () {
    var n;
    if ("ontouchstart" in e || (e.DocumentTouch && t instanceof DocumentTouch)) n = !0;
    else {
      var o = ["@media (", p.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
      h(o, function (e) {
        n = 9 === e.offsetTop;
      });
    }
    return n;
  }),
    r(),
    a(c),
    delete u.addTest,
    delete u.addAsyncTest;
  for (var v = 0; v < Modernizr._q.length; v++) Modernizr._q[v]();
  e.Modernizr = Modernizr;
})(window, document);
